export interface Cdn {
  id: number;
  as_num: string;
  as_name: string;
  tipo: string;
  bloco: string;
}

export type CdnPayload = Omit<Cdn, "id">;

export type CdnFormErrors = Partial<Record<keyof CdnPayload, string>>;

export interface CdnsApiResponse {
  success: boolean;
  data: Cdn[];
}

export const CDN_FIELDS: Array<keyof CdnPayload> = [
  "as_name",
  "as_num",
  "tipo",
  "bloco",
];

export const emptyCdn: CdnPayload = {
  as_num: "",
  as_name: "",
  tipo: "",
  bloco: "",
};
